/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BlockItem } from './BlockItem';
import {
    BlockItemFromJSON,
    BlockItemFromJSONTyped,
    BlockItemToJSON,
} from './BlockItem';
import type { Footer } from './Footer';
import {
    FooterFromJSON,
    FooterFromJSONTyped,
    FooterToJSON,
} from './Footer';
import type { HelpLink } from './HelpLink';
import {
    HelpLinkFromJSON,
    HelpLinkFromJSONTyped,
    HelpLinkToJSON,
} from './HelpLink';
import type { Parent } from './Parent';
import {
    ParentFromJSON,
    ParentFromJSONTyped,
    ParentToJSON,
} from './Parent';
import type { WidgetRow } from './WidgetRow';
import {
    WidgetRowFromJSON,
    WidgetRowFromJSONTyped,
    WidgetRowToJSON,
} from './WidgetRow';

/**
 * 
 * @export
 * @interface DynamicFrontPage
 */
export interface DynamicFrontPage {
    /**
     * 
     * @type {number}
     * @memberof DynamicFrontPage
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DynamicFrontPage
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof DynamicFrontPage
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof DynamicFrontPage
     */
    type?: string;
    /**
     * 
     * @type {Parent}
     * @memberof DynamicFrontPage
     */
    parent?: Parent;
    /**
     * 
     * @type {string}
     * @memberof DynamicFrontPage
     */
    urlName?: string;
    /**
     * 
     * @type {string}
     * @memberof DynamicFrontPage
     */
    readonly updateDate?: string;
    /**
     * 
     * @type {Date}
     * @memberof DynamicFrontPage
     */
    publishedDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof DynamicFrontPage
     */
    helpText?: string;
    /**
     * 
     * @type {string}
     * @memberof DynamicFrontPage
     */
    helpVideo?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DynamicFrontPage
     */
    showHelp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DynamicFrontPage
     */
    showExtendedHelp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DynamicFrontPage
     */
    pushContent?: boolean;
    /**
     * 
     * @type {Array<HelpLink>}
     * @memberof DynamicFrontPage
     */
    helpLinks?: Array<HelpLink>;
    /**
     * 
     * @type {string}
     * @memberof DynamicFrontPage
     */
    status?: string;
    /**
     * 
     * @type {Array<WidgetRow>}
     * @memberof DynamicFrontPage
     */
    widgetRows?: Array<WidgetRow>;
    /**
     * 
     * @type {boolean}
     * @memberof DynamicFrontPage
     */
    alwaysShowTitleBar?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DynamicFrontPage
     */
    titleBarImageLogo?: string;
    /**
     * 
     * @type {Footer}
     * @memberof DynamicFrontPage
     */
    footer?: Footer;
    /**
     * 
     * @type {boolean}
     * @memberof DynamicFrontPage
     */
    useNewFrontpage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DynamicFrontPage
     */
    showLanguageSelector?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DynamicFrontPage
     */
    moduleCompactView?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DynamicFrontPage
     */
    automaticModuleCompletion?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DynamicFrontPage
     */
    frontpageHeader?: string;
    /**
     * 
     * @type {Array<BlockItem>}
     * @memberof DynamicFrontPage
     */
    blockList?: Array<BlockItem>;
    /**
     * 
     * @type {boolean}
     * @memberof DynamicFrontPage
     */
    navigationBetweenModules?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DynamicFrontPage
     */
    showNotificationCenter?: boolean;
}

/**
 * Check if a given object implements the DynamicFrontPage interface.
 */
export function instanceOfDynamicFrontPage(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DynamicFrontPageFromJSON(json: any): DynamicFrontPage {
    return DynamicFrontPageFromJSONTyped(json, false);
}

export function DynamicFrontPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): DynamicFrontPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'url': !exists(json, 'Url') ? undefined : json['Url'],
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'parent': !exists(json, 'Parent') ? undefined : ParentFromJSON(json['Parent']),
        'urlName': !exists(json, 'UrlName') ? undefined : json['UrlName'],
        'updateDate': !exists(json, 'UpdateDate') ? undefined : json['UpdateDate'],
        'publishedDate': !exists(json, 'PublishedDate') ? undefined : (new Date(json['PublishedDate'])),
        'helpText': !exists(json, 'HelpText') ? undefined : json['HelpText'],
        'helpVideo': !exists(json, 'HelpVideo') ? undefined : json['HelpVideo'],
        'showHelp': !exists(json, 'ShowHelp') ? undefined : json['ShowHelp'],
        'showExtendedHelp': !exists(json, 'ShowExtendedHelp') ? undefined : json['ShowExtendedHelp'],
        'pushContent': !exists(json, 'PushContent') ? undefined : json['PushContent'],
        'helpLinks': !exists(json, 'HelpLinks') ? undefined : ((json['HelpLinks'] as Array<any>).map(HelpLinkFromJSON)),
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'widgetRows': !exists(json, 'WidgetRows') ? undefined : ((json['WidgetRows'] as Array<any>).map(WidgetRowFromJSON)),
        'alwaysShowTitleBar': !exists(json, 'AlwaysShowTitleBar') ? undefined : json['AlwaysShowTitleBar'],
        'titleBarImageLogo': !exists(json, 'TitleBarImageLogo') ? undefined : json['TitleBarImageLogo'],
        'footer': !exists(json, 'Footer') ? undefined : FooterFromJSON(json['Footer']),
        'useNewFrontpage': !exists(json, 'UseNewFrontpage') ? undefined : json['UseNewFrontpage'],
        'showLanguageSelector': !exists(json, 'ShowLanguageSelector') ? undefined : json['ShowLanguageSelector'],
        'moduleCompactView': !exists(json, 'ModuleCompactView') ? undefined : json['ModuleCompactView'],
        'automaticModuleCompletion': !exists(json, 'AutomaticModuleCompletion') ? undefined : json['AutomaticModuleCompletion'],
        'frontpageHeader': !exists(json, 'FrontpageHeader') ? undefined : json['FrontpageHeader'],
        'blockList': !exists(json, 'BlockList') ? undefined : ((json['BlockList'] as Array<any>).map(BlockItemFromJSON)),
        'navigationBetweenModules': !exists(json, 'NavigationBetweenModules') ? undefined : json['NavigationBetweenModules'],
        'showNotificationCenter': !exists(json, 'ShowNotificationCenter') ? undefined : json['ShowNotificationCenter'],
    };
}

export function DynamicFrontPageToJSON(value?: DynamicFrontPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Title': value.title,
        'Url': value.url,
        'Type': value.type,
        'Parent': ParentToJSON(value.parent),
        'UrlName': value.urlName,
        'PublishedDate': value.publishedDate === undefined ? undefined : (value.publishedDate.toISOString()),
        'HelpText': value.helpText,
        'HelpVideo': value.helpVideo,
        'ShowHelp': value.showHelp,
        'ShowExtendedHelp': value.showExtendedHelp,
        'PushContent': value.pushContent,
        'HelpLinks': value.helpLinks === undefined ? undefined : ((value.helpLinks as Array<any>).map(HelpLinkToJSON)),
        'Status': value.status,
        'WidgetRows': value.widgetRows === undefined ? undefined : ((value.widgetRows as Array<any>).map(WidgetRowToJSON)),
        'AlwaysShowTitleBar': value.alwaysShowTitleBar,
        'TitleBarImageLogo': value.titleBarImageLogo,
        'Footer': FooterToJSON(value.footer),
        'UseNewFrontpage': value.useNewFrontpage,
        'ShowLanguageSelector': value.showLanguageSelector,
        'ModuleCompactView': value.moduleCompactView,
        'AutomaticModuleCompletion': value.automaticModuleCompletion,
        'FrontpageHeader': value.frontpageHeader,
        'BlockList': value.blockList === undefined ? undefined : ((value.blockList as Array<any>).map(BlockItemToJSON)),
        'NavigationBetweenModules': value.navigationBetweenModules,
        'ShowNotificationCenter': value.showNotificationCenter,
    };
}

